















import {Component, Vue, Prop} from 'vue-property-decorator';
import IconLabelFeatured from '@/components/icons/IconLabelFeatured.vue';
import IconLabelOffer from '@/components/icons/IconLabelOffer.vue';
import IconLabelTrending from '@/components/icons/IconLabelTrending.vue';
import type {TItemLabelName, VueComponent} from '@customer-portal/shared';

interface ILabelDefinition {
	displayText: string;
	icon: VueComponent;
}
type TLabelDefinitions = Record<TItemLabelName, ILabelDefinition>;

const LABEL_DEFINITIONS: TLabelDefinitions = {
	trending: {
		displayText: 'Trending',
		icon: IconLabelTrending,
	},
	offer: {
		displayText: 'Offer available',
		icon: IconLabelOffer,
	},
	featured: {
		displayText: 'Featured',
		icon: IconLabelFeatured,
	}
};

@Component
export default class ItemLabelCarousel extends Vue {
	@Prop({required: true})
	itemLabels!: TItemLabelName[];

	private activeLabelIndex = 0;
	private intervalId!: any;

	get labelConstants(): TLabelDefinitions {
		return LABEL_DEFINITIONS;
	}

	mounted() {
		const el = (this.$refs.labelContainers as HTMLDivElement[])?.[this.activeLabelIndex];
		if(el) {
			el.style.opacity = '1';
			this.intervalId = setInterval(() => {
				// set opacity of current label to 0
				let activeLabelElement = (this.$refs.labelContainers as HTMLDivElement[])[this.activeLabelIndex];
				if(activeLabelElement) {
					activeLabelElement.style.opacity = '0';
				}
				// get index of next label to show
				this.activeLabelIndex = (this.activeLabelIndex === this.itemLabels.length - 1) ? 0 : this.activeLabelIndex + 1;
				// set opacity of next label to 1
				activeLabelElement = (this.$refs.labelContainers as HTMLDivElement[])[this.activeLabelIndex];
				if(activeLabelElement) {
					activeLabelElement.style.opacity = '1';
				}
			}, 2500);
		}
	}

	unmounted() {
		clearInterval(this.intervalId);
	}
}
